// imports
import WCarousel from './WCarousel';

// private statics

// class definition
export default class MediaCarousel extends WCarousel {
    // constructor
    constructor (args = {}, objectName = 'MediaCarousel') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);
    }

    // methods
    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
